import React, { PureComponent } from "react";
import FieldContainer from "../components/FieldContainer";
import ImageUploader from "../components/ImageUploader";
import { isFieldLocked } from "../components/utils";
export default class ImageField extends PureComponent {
  static defaultProps = {
    inputType: "text",
    value: "",
    required: false
  };

  render() {
    const { id, name, value, onChange, placeholder, width = 200, height = 200, required, disabled, locked } = this.props;
    const imageValue = value && typeof value === "string" ? JSON.parse(value) || {} : value;
    const isLocked = isFieldLocked(name, locked);
    return (
      <FieldContainer {...this.props} isUploader>
        <ImageUploader
          id={id}
          style={{ width, height }}
          field={name}
          value={imageValue}
          required={required}
          disabled={disabled || isLocked}
          onChange={onChange}
          placeholder={placeholder}
        />
        {value && <input type="hidden" name={name} value={JSON.stringify(imageValue)} />}
      </FieldContainer>
    );
  }
}
